// Campus photo for /colleges/oklahoma-state-university: CC BY-SA 3.0, by Helluvamatt, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AEdmon_Low_Library.jpg), checked 2026-10-02 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/oklahoma-state-university/; credited under the photo.
const photo = {
    "slug": "oklahoma-state-university",
    "alt": "Edmon Low Library and its clock tower on the Oklahoma State University campus in Stillwater",
    "src": "/colleges/oklahoma-state-university/campus-1600.webp",
    "srcSmall": "/colleges/oklahoma-state-university/campus-800.webp",
    "srcMid": "/colleges/oklahoma-state-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/oklahoma-state-university/og.jpg",
    "title": "Edmon Low Library",
    "author": "Helluvamatt",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AEdmon_Low_Library.jpg",
    "read": "2026-10-02"
};

export default photo;
